// extracted by mini-css-extract-plugin
export default {"label":"wIw2tva1Me","dark":"GyPjIN4lAi"};